import {EmailField} from 'react-admin';

const EmailFieldMod = props => {
    return (<EmailField {...props} emptyText={'-'} />);
};

export default EmailFieldMod;